var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "vx-card",
        [
          _c(
            "div",
            { staticClass: "flex flex-wrap justify-between items-center" },
            [
              _c(
                "div",
                { staticClass: "mb-4 md:mb-0 mr-4 ag-grid-table-actions-left" },
                [
                  _c(
                    "vs-dropdown",
                    {
                      staticClass: "cursor-pointer",
                      attrs: { "vs-trigger-click": "" },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium",
                        },
                        [
                          _c("span", { staticClass: "mr-2" }, [
                            _vm._v(_vm._s(_vm.GeneratePageSizeButton())),
                          ]),
                          _c("feather-icon", {
                            attrs: {
                              icon: "ChevronDownIcon",
                              svgClasses: "h-4 w-4",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "vs-dropdown-menu",
                        [
                          _c(
                            "vs-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.chargesGridApi.paginationSetPageSize(
                                    20
                                  )
                                },
                              },
                            },
                            [_c("span", [_vm._v("20")])]
                          ),
                          _c(
                            "vs-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.chargesGridApi.paginationSetPageSize(
                                    50
                                  )
                                },
                              },
                            },
                            [_c("span", [_vm._v("50")])]
                          ),
                          _c(
                            "vs-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.chargesGridApi.paginationSetPageSize(
                                    100
                                  )
                                },
                              },
                            },
                            [_c("span", [_vm._v("100")])]
                          ),
                          _c(
                            "vs-dropdown-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.chargesGridApi.paginationSetPageSize(
                                    150
                                  )
                                },
                              },
                            },
                            [_c("span", [_vm._v("150")])]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-wrap items-center justify-between ag-grid-table-actions-right",
                },
                [
                  _c("vs-input", {
                    staticClass: "mb-4 md:mb-0 mr-4",
                    attrs: { placeholder: "Buscar..." },
                    on: { input: _vm.updateChargesSearchQuery },
                    model: {
                      value: _vm.chargesSearchQuery,
                      callback: function ($$v) {
                        _vm.chargesSearchQuery = $$v
                      },
                      expression: "chargesSearchQuery",
                    },
                  }),
                  _c(
                    "vs-button",
                    {
                      staticClass: "mb-4 md:mb-0 mr-4",
                      on: {
                        click: function ($event) {
                          return _vm.chargesGridApi.exportDataAsExcel({
                            rowHeight: 20,
                          })
                        },
                      },
                    },
                    [_vm._v("Exportar Excel")]
                  ),
                  _c(
                    "vx-tooltip",
                    { attrs: { text: "Refrescar datos" } },
                    [
                      _c("vs-button", {
                        staticClass: "mb-4 md:mb-0 mr-4",
                        attrs: {
                          radius: "",
                          color: "primary",
                          type: "border",
                          "icon-pack": "feather",
                          icon: "icon-refresh-cw",
                        },
                        on: { click: _vm.updateData },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "vx-tooltip",
                    { attrs: { color: "dark", text: "Limpiar filtros" } },
                    [
                      _c("vs-button", {
                        attrs: {
                          radius: "",
                          color: "danger",
                          type: "border",
                          "icon-pack": "feather",
                          icon: "icon-x",
                        },
                        on: { click: _vm.resetFilters },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c("ag-grid-vue", {
            ref: "agGridTable",
            staticClass: "ag-theme-material w-100 my-4 ag-grid-table",
            attrs: {
              gridOptions: _vm.chargesGridOptions,
              columnDefs: _vm.columns,
              defaultColDef: _vm.chargesDefaultColDef,
              rowData: _vm.data,
              rowSelection: "multiple",
              rowMultiSelectWithClick: "true",
              enableRangeSelection: true,
              colResizeDefault: "shift",
              animateRows: true,
              floatingFilter: true,
              getContextMenuItems: _vm.getChargesContextMenuItems,
              pagination: true,
              paginationPageSize: _vm.chargesPaginationPageSize,
              suppressPaginationPanel: true,
              tooltipShowDelay: "0",
              frameworkComponents: _vm.frameworkComponents,
            },
            on: { "selection-changed": _vm.onSelectionChanged },
          }),
          _c("vs-pagination", {
            attrs: {
              total: _vm.chargesTotalPages,
              max: _vm.chargesMaxPageNumbers,
            },
            model: {
              value: _vm.chargesCurrentPage,
              callback: function ($$v) {
                _vm.chargesCurrentPage = $$v
              },
              expression: "chargesCurrentPage",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }